export const TransactionSubRowTransformer = (transactionPartData) => {
  const returnValue = transactionPartData.transactionsParts;
  if (returnValue !== undefined) {
    returnValue.map((payment) => {
      if (payment.paidAmount < 0) {
        payment.cssClass = "ReversePaymentClassName";
      } else {
        payment.cssClass = "";
      }
      return payment;
    });
    return returnValue;
  }
};
